import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { getPrimaryOffer } from '../api/salesforce';
import { UserContext } from './UserContext';
import { WalesContext } from './WalesContext';

export const BasketContext = React.createContext({
  basketData: {},
  setBasketData: () => {},
});

const BasketProvider = ({ children }) => {
  const [basketData, setBasketData] = useState({
    offerId: null,
    unitId: null,
    unitName: null,
    postCode: null,
    bedrooms: null,
    furnished: null,
    monthlyRent: null,
    moveInDate: null,
    term: null,
    wishList: null,
    periodicity: null,
    breakClause: null,
    agreementType: null,
  });

  const { opportunityId } = useContext(UserContext);
  const { setIsWales } = useContext(WalesContext);

  useEffect(() => {
    async function fetchData() {
      if (!opportunityId) return;

      const offer = await getPrimaryOffer(opportunityId);
      if (!offer) return;

      const {
        id,
        term,
        wishList,
        breakClause,
        agreementType,
        monthlyRent,
        unit,
        opportunity,
      } = offer;

      if (unit === null || unit === undefined) return;

      setBasketData({
        unitId: unit.Id,
        offerId: id,
        unitName: unit.Name,
        postCode: unit.Post_Code__c,
        bedrooms: unit.Bedrooms__c,
        furnished: unit.Furnished__c,
        monthlyRent,
        moveInDate: opportunity.Move_In_Date__c,
        periodicity: opportunity.Payment_Periodicity__c,
        term,
        wishList,
        breakClause,
        agreementType,
      });

      setIsWales(unit.isWales);
    }

    fetchData();
  }, [opportunityId, setIsWales]);

  return (
    <BasketContext.Provider value={{ basketData, setBasketData }}>
      {children}
    </BasketContext.Provider>
  );
};

BasketProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default BasketProvider;
